/* eslint-disable */
/**
 * Checks if the app's display mode is "standalone".
 * @returns {boolean} true if app's display mode is "standalone", otherwise false.
 */
const isStandAlone = () => window.matchMedia && window.matchMedia(`(display-mode: standalone)`).matches;

export default isStandAlone;
